import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { dataGridNumberSorter } from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { useYesNoDataGridFilter } from '../../../../common/DataGrid/filters/DataGridFilters.jsx';

const ResponseTable = ({
  pollsResponseCollections,
  onDetailClick,
  customSettings,
}) => {
  const { t } = useTranslation();

  const nameFilterProps = useDataGridTextFilter('name');
  const activeFilterProps = useYesNoDataGridFilter('is_active');
  //const nameFilterProps = useDataGridTextFilter('name');

  const columns = useMemo(
    () => [
      {
        title: t('Názov kolekcie odpovedí'),
        dataIndex: 'name',
        ...nameFilterProps,
      },
      {
        title: t('Počet odpovedí'),
        dataIndex: 'answersCount',
        sorter: dataGridNumberSorter('answersCount'),
      },
      {
        title: t('Aktívna'),
        dataIndex: 'is_active',
        ...activeFilterProps,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <DataGrid
      rowKey="id"
      dataSource={pollsResponseCollections || []}
      columns={columns}
      onRowClick={onDetailClick}
      permissionsBasic={'response-collections'}
      customSettings={customSettings}
      uniqueTableId={'response-collections-table'}
    />
  );
};

ResponseTable.propTypes = {
  pollsResponseCollections: PropTypes.any,
  onDetailClick: PropTypes.func,
  customSettings: PropTypes.any,
};

export default ResponseTable;
